export enum SortFieldSupplier {
  ESN = "esn",
  Supplier = "name",
  SubscriptionStatus = "status",
  StartDate = "startDate",
  EndDate = "endDate",
  Recipients = "recipients",
  DayOfWeek = "dayOfWeek",
}
